/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ActivityArea } from './';
import {
    ActivityAreaFromJSON,
    ActivityAreaFromJSONTyped,
    ActivityAreaToJSON,
} from './';
import type { OrganizationSizeResource } from './';
import {
    OrganizationSizeResourceFromJSON,
    OrganizationSizeResourceFromJSONTyped,
    OrganizationSizeResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface OrganizationIndicatorsResource
 */
export interface OrganizationIndicatorsResource {
    /**
     * 
     * @type {OrganizationSizeResource}
     * @memberof OrganizationIndicatorsResource
     */
    organizationSize?: OrganizationSizeResource;
    /**
     * 
     * @type {ActivityArea}
     * @memberof OrganizationIndicatorsResource
     */
    activityArea?: ActivityArea;
    /**
     * 
     * @type {number}
     * @memberof OrganizationIndicatorsResource
     */
    numberOfCompanies: number;
    /**
     * 
     * @type {number}
     * @memberof OrganizationIndicatorsResource
     */
    numberOfMembers: number;
}

/**
 * Check if a given object implements the OrganizationIndicatorsResource interface.
 */
export function instanceOfOrganizationIndicatorsResource(value: object): value is OrganizationIndicatorsResource {
    if (!('numberOfCompanies' in value) || value['numberOfCompanies'] === undefined) return false;
    if (!('numberOfMembers' in value) || value['numberOfMembers'] === undefined) return false;
    return true;
}

export function OrganizationIndicatorsResourceFromJSON(json: any): OrganizationIndicatorsResource {
    return OrganizationIndicatorsResourceFromJSONTyped(json, false);
}

export function OrganizationIndicatorsResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationIndicatorsResource {
    if (json == null) {
        return json;
    }
    return {
        
        'organizationSize': json['organizationSize'] == null ? undefined : OrganizationSizeResourceFromJSON(json['organizationSize']),
        'activityArea': json['activityArea'] == null ? undefined : ActivityAreaFromJSON(json['activityArea']),
        'numberOfCompanies': json['numberOfCompanies'],
        'numberOfMembers': json['numberOfMembers'],
    };
}

export function OrganizationIndicatorsResourceToJSON(value?: OrganizationIndicatorsResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'organizationSize': OrganizationSizeResourceToJSON(value['organizationSize']),
        'activityArea': ActivityAreaToJSON(value['activityArea']),
        'numberOfCompanies': value['numberOfCompanies'],
        'numberOfMembers': value['numberOfMembers'],
    };
}

